<template>
  <div
    class=""
    style="
    "
  >
    <div
      class="row justify-content-center"
      style="direction: rtl; text-align: right; font-size: 16px"
    >

      <div class="w-100"></div>
      <div
        class="col-12 p-2"
        v-html="getAnalysis()"
        style="
          font-size: 16px;
          text-align: right;
          background: #f9f9f9;
          border-radius: 8px;
          width: calc(100% - 30px);
          border: 1px solid rgba(238, 238, 238, 0.5);
          line-height: 3rem;
          direction: rtl;
          color: #000;
        "
      ></div>
      <div class="w-100"></div>
    </div>
  </div>
</template>

<script>
import moment from 'jalali-moment'
import HelperLib from './helper'

export default {
  name: 'ChartAnalysis',
  props: ['data'],
  components: {
    HelperLib,
  },
  data() {
    return {
      analysis: [],
    }
  },
  methods: {
    getLagnaStatement() {
      var lagna_exp = HelperLib.rashiToPersianText(this.data['lagna']['Lg']['rashi'])
      var lagna =
        '<img class="m-2" src="' +
        HelperLib.getLagnaImagePath(this.data['lagna']['Lg']['rashi_name']) +
        '" width="24" />'
      lagna +=
        ' رایزینگ این چارت ' +
        '<a href="' +
        lagna_exp[1] +
        '" target=_blank>' +
        lagna_exp[0] +
        '</a>' +
        ' است برای شنیدن تفسیر این ' +
        '<a href="' +
        lagna_exp[1] +
        '" target=_blank>صفحه</a>' +
        ' را ببینید'
      return lagna
    },
    getAnalysis() {
      let statement = ''
      let oh_ex_list = []
      let db_list = []
      let statments = []

      if (this.data['analysis']) {
        for (var [key, value] of Object.entries(this.data['analysis']['planets'])) {
          if (!value) continue
          if (value[2]) {
            oh_ex_list.push(value)
          }
          if (value[1]) {
            db_list.push(value)
          }
          if (value[3]) {
            statments.push(value)
          }
        }
      }
      // console.log(statments)

      let oh_ex_info = ''
      if (oh_ex_list.length > 0) {
        oh_ex_info = 'در این چارت '
        let oh_ex_len = 0
        for (var item of Object.entries(oh_ex_list)) {
          // console.log(item)
          oh_ex_info +=
            '<a style=" \
            font-weight: bold; \
            border-radius: 5px; \
            padding: 3px; \
            text-shadow: 1px 1px #ffffff;" \
            target=_blank \
            href=' +
            HelperLib.grahaToPersianText(item[1][0])[1] +
            '>' +
            HelperLib.grahaToPersianText(item[1][0])[0] +
            '</a>'
          if (oh_ex_list.length > 1 && oh_ex_len != oh_ex_list.length - 1) {
            oh_ex_info += ' و '
          } else {
            oh_ex_info += ' '
          }
          oh_ex_len++
        }
        oh_ex_info +=
          'در وضعیت <span style="font-weight: bold; text-shadow: 1px 1px #ffffff;" >قدرتمند</span> قرار '
        if (oh_ex_list.length == 1) {
          oh_ex_info += 'دارد'
        } else {
          oh_ex_info += 'دارند'
        }
      }

      let db_info = ''
      if (db_list.length > 0) {
        db_info = 'در این چارت '
        let db_len = 0
        for (var item of Object.entries(db_list)) {
          db_info +=
            '<a style=" \
            font-weight: bold; \
            padding: 3px; \
            text-shadow: 1px 1px #ffffff;" \
            target=_blank \
            href=' +
            HelperLib.grahaToPersianText(item[1][0])[1] +
            '>' +
            HelperLib.grahaToPersianText(item[1][0])[0] +
            '</a>'
          if (db_list.length > 1 && db_len != db_list.length - 1) {
            db_info += ' و '
          } else {
            db_info += ' '
          }
          db_len++
        }
        db_info +=
          'در وضعیت <span style="font-weight: bold; text-shadow: 1px 1px #ffffff;" >ضعیف</span> قرار '
        if (db_list.length == 1) {
          db_info += ' دارد'
        } else {
          db_info += ' دارند'
        }
      }

      let result = ''

      if (oh_ex_list.length > 0) {
        result +=
          "<span style='background-color: rgba(51, 153, 102, 0.1); padding: 3px; border-radius: 5px;'>" +
          oh_ex_info +
          '</span>'
      }
      if (db_list.length > 0) {
        if (oh_ex_list.length > 0) {
          result += '. </br>'
          result +=
            "<span style='background-color: rgba(227, 18, 42, 0.1); padding: 3px; border-radius: 5px;'>"
          result += ' همچنین ' + db_info
          result += '</span>'
          result += '.'
        } else {
          result += db_info
          result += '</span>'
          result += '.'
        }
      }

      result += '<br/>'

      let stat_info = ''
      // console.log(statments)
      if (statments.length > 0) {
        stat_info = 'در این چارت '
        let stat_len = 0
        for (var item of Object.entries(statments)) {
          if (stat_len > 0) {
            stat_info += ' <br/> '
          }
          if (item[1][0] == 'Ra' || item[1][0] == 'Ke') {
            stat_info +=
              '<span style="text-shadow: 1px 1px white; background-color: rgba(227, 18, 42, 0.1); padding: 3px; border-radius: 5px;">'
          }
          if (db_list.length == 0 && oh_ex_list.length > 0 && item[1][0] != 'Ra' && item[1][0] != 'Ke') {
            stat_info +=
              '<span style="text-shadow: 1px 1px white; background-color: rgba(51, 153, 102, 0.1); padding: 3px; border-radius: 5px;">'
          }
          if (db_list.length > 0 && oh_ex_list.length == 0 && item[1][0] != 'Ra' && item[1][0] != 'Ke') {
            stat_info +=
              '<span style="text-shadow: 1px 1px white; background-color: rgba(227, 18, 42, 0.1); padding: 3px; border-radius: 5px;">'
          }
          stat_info +=
            '<a style=" \
            font-weight: bold; \
            border-radius: 5px; \
            padding: 3px; \
            text-shadow: 1px 1px #ffffff;" \
            target=_blank \
            href=' +
            HelperLib.grahaToPersianText(item[1][0])[1] +
            '>' +
            HelperLib.grahaToPersianText(item[1][0])[0] +
            '</a>'
          stat_info += item[1][3]
          if (item[1][0] == 'Ra' || item[1][0] == 'Ke') {
            stat_info += '</span>'
          }
          if (db_list.length == 0 && oh_ex_list.length > 0 && item[1][0] != 'Ra' && item[1][0] != 'Ke') {
            stat_info += '</span>'
          }
          if (db_list.length > 0 && oh_ex_list.length == 0 && item[1][0] != 'Ra' && item[1][0] != 'Ke') {
            stat_info += '</span>'
          }
          ++stat_len
        }
      }

      let dasha_stat = this.getDashaStatement(this.data)

      const atma_stat = "<span class='bg-white'>" + this.getAtmaStatement(this.data['analysis']['karakas']) + "</span>";
      return result + stat_info + dasha_stat + atma_stat
    },
    formatLagnaText(rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink(data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    },
    getPad(data) {
      return HelperLib.paddy(data, 2, 0)
    },
    getAtmaStatement(data){
      const atmas = {
        "Su": "در چارت تولد شما خورشید آتماکاراکا است و می‌تواند نشان‌دهنده این باشد که شما برای شهرت و شناخته‌شدن به عنوان فردی قوی تلاش خواهید کرد.به  قدرت و رهبری علاقه دارید. غرور خود را کنترل کنید و از قدرت برای اهداف مثبت استفاده کنید.",
        "Mo": "در چارت تولد شما ماه آتماکاراکا است و می‌تواند نشان‌دهنده این باشد که شما دارای طبیعتی عمیقا احساسی و ارتباط قوی با ریشه و خانواده خود هستید. به دنبال امنیت و پایداری هستید. شاد زندگی کنید و به دیگران عشق بورزید.",
        "Ma": "در چارت تولد شما مارس آتماکاراکا است و می‌تواند نشان‌دهنده این باشد که شما دارای تمایل قوی برای اقدام، ماجراجویی و رقابت هستید. ممکن است استعداد طبیعی برای فعالیت جسمانی و زندگی پویا داشته باشید. برای تعادل انرژی خشمگین نشوید.",
        "Me": "در چارت تولد شما مرکوری آتماکاراکا است و می‌تواند نشان‌دهنده این باشد که دارای ذهنی کنجکاو هستید. ممکن است استعداد طبیعی برای ارتباط داشته باشید و بتوانید خود را از طریق نوشتن یا بیان کلمات مطرح کنید. برای تعادل انرژی همیشه حقیقت را بگویید.",
        "Ju": "در چارت تولد شما ژویپتر آتماکاراکا است و می‌تواند نشان‌دهنده این باشد که دارای طبیعت عمیقا معنوی و حس خودشناسی هستید. به دنبال زندگی معنوی و هدفمند هستید و ممکن است استعداد راهنمایی دیگران را داشته باشید.",
        "Ve": "در چارت تولد شما ونوس آتماکاراکا است و می‌تواند نشان‌دهنده این باشد که دارای طبیعت هنری و علاقه‌مند به زیبایی‌شناسی هستید. ممکن است به هنر علاقه داشته باشید. داشتن رابطه عاطفی پایدار برای شما است. برای تعادل انرژی در عشق افراط نکنید.",
        "Sa": "در چارت تولد شما سترن آتماکاراکا است و می‌تواند نشان‌دهنده این باشد که دارای طبیعتی مسئولیت‌پذیر هستید و نطم برایتان اهمیت دارد. برای تعادل انرژی سعی کنید همیشه نسبت به مسائل واقع‌بین باشید.",
        "Ra": "در چارت تولد شما راهو آتماکاراکا است و می‌تواند نشان‌دهنده این باشد که هدفی خاص را برای زندگیتان دنبال می‌کنید. ممکن است در مسیر زندگیتان اتفاقاتی غیرعادی را تجربه کنید. برای تعادل انرژی سعی کنید وسواس روی مادیات را کنار بگذارید."
      }
      const text = "<br/>" + atmas[data];
      return text
    },
    getDashaStatement(data) {
      // console.log(dasha)
      let dasha = data['dasha']['vimshottari']['periods']
      for (const key in dasha) {
        if (Object.hasOwnProperty.call(dasha, key)) {
          // console.log(key)
          let item = dasha[key]
          // console.log(item)
          let start = item['start']
          let end = item['end']
          if (data['user']['date_type'] == 'jalali') {
            var s_mo = moment.from(start, 'fa', 'jYYYY-jMM-jDD')
            var e_mo = moment.from(end, 'fa', 'jYYYY-jMM-jDD')
            var now = moment()
            now = now.locale('fa')
            if (now.isBetween(s_mo, e_mo)) {
              let _graha = HelperLib.grahaToPersianText(HelperLib.sansToEngGraha(item['key']))
              let out =
                "<br/><span style='background-color: rgba(255, 255, 255, 0.5); font-weight: bold;'>"
              out +=
                ' شما هم‌اکنون در دوره‌ سیاره‌ ' +
                '<a href="' + _graha[1] + '" target=_blank >' +
                  _graha[0] +
                '</a>' +
                ' قرار دارید.'
              out += '</span>'
              return out
            }
          }
          if (data['user']['date_type'] == 'gregorian') {
            var s_mo = moment.from(start, 'en', 'YYYY-MM-DD')
            var e_mo = moment.from(end, 'en', 'YYYY-MM-DD')
            var now = moment()
            now = now.locale('en')
            if (now.isBetween(s_mo, e_mo)) {
              let out =
                "<br/><span style='background-color: rgba(255, 255, 255, 0.5); font-weight: bold;'>"
              out +=
                ' شما هم‌اکنون در دوره‌ سیاره‌ ' +
                HelperLib.sansToEngGraha(item['key']) +
                ' قرار دارید.'
              out += '</span>'
              return out
            }
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.chart-analysis {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  height: 50px;
  font-size: 16px;
  flex: 1;
  text-align: center;
  background-color: #f9f9f9;
  background-repeat: no-repeat;
  background-position: calc(100% - 10px);
  margin: 0;
}

.analys-list {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY2FsZW5kYXItZXZlbnQiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTExIDYuNWEuNS41IDAgMCAxIC41LS41aDFhLjUuNSAwIDAgMSAuNS41djFhLjUuNSAwIDAgMS0uNS41aC0xYS41LjUgMCAwIDEtLjUtLjV2LTF6Ii8+CiAgPHBhdGggZD0iTTMuNSAwYS41LjUgMCAwIDEgLjUuNVYxaDhWLjVhLjUuNSAwIDAgMSAxIDBWMWgxYTIgMiAwIDAgMSAyIDJ2MTFhMiAyIDAgMCAxLTIgMkgyYTIgMiAwIDAgMS0yLTJWM2EyIDIgMCAwIDEgMi0yaDFWLjVhLjUuNSAwIDAgMSAuNS0uNXpNMSA0djEwYTEgMSAwIDAgMCAxIDFoMTJhMSAxIDAgMCAwIDEtMVY0SDF6Ii8+Cjwvc3ZnPg==);
}

.chart-phrase a {
  text-decoration: none;
}

.chart-cta:hover {
  text-shadow: rgba(0, 0, 0, 0.6) 0px 1px 1px;
}

.animated-bg {
  background: linear-gradient(175deg, #fffac0, #fffde7);
  background-size: 400% 400%;

  -webkit-animation: AnimationName 0s ease infinite;
  -moz-animation: AnimationName 0s ease infinite;
  animation: AnimationName 0s ease infinite;
}

@-webkit-keyframes AnimationName {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@-moz-keyframes AnimationName {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes AnimationName {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
